import { Navigate, useOutletContext } from 'react-router-dom'

import { Box, Title } from '@factorialco/deprecated-design-system'
import { EmployeesGoalsPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import type { RouteContext } from 'modules/employees/lib/types'
import GoalConfigTable from 'modules/goals/components/Table'
import goalsConfig from 'modules/goals/store/collections/goalsconfig'
import Page from 'modules/layout/components/Page'

type ContentProps = {
  canSeeClockedIn: boolean
}

const Content = ({ canSeeClockedIn }: ContentProps) => {
  return (
    <Box gap="s32">
      <Title
        illustration="performance_management"
        title={i18n.t('goals.index.title')}
        description={i18n.t('goals.employee.description')}
      />
      <GoalConfigTable canSeeClockedIn={canSeeClockedIn} />
    </Box>
  )
}

const GoalsPage = observer(() => {
  const { employee, loadingModuleAvailabilities, hasGoals } = useOutletContext<RouteContext>()

  const userId = employee.attributes.access_id

  const { loading: loadingAsyncData } = useAsyncData(
    () =>
      goalsConfig.fetch({
        data: {
          owner_id: userId,
        },
      }),
    []
  )

  const { navigation } = useNavigation()

  const { loading: loadingGraphQl, data } = useQuery(EmployeesGoalsPageDocument)

  const canSeeClockedIn = data?.attendance._policies.companySeeClockedIn.can || false
  const loading = loadingAsyncData || loadingGraphQl || loadingModuleAvailabilities

  if (loading) return <Loading />

  if (!hasGoals && users.current.policy.can('apiCore.accessGoalsConfigCreate'))
    return <Navigate to={navigation.appStore.fullPath()} />

  if (!hasGoals) return <NotFound />

  return (
    <Page.Body>
      <Content canSeeClockedIn={canSeeClockedIn} />
    </Page.Body>
  )
})

export default GoalsPage
